import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderMobileService {
	missionAnnouncedSource = new Subject<any>();
	// Observable string streams
	missionAnnounced$ = this.missionAnnouncedSource.asObservable();
	// Service message commands
	headerSubject = new ReplaySubject<any>(1);

	constructor() {}

	announceMission(mission: any) {
		this.missionAnnouncedSource.next(mission);
	}
}
